{
  "API Log": "API Log",
  "Menu": "Menü",
  "admin": {
    "Database": "Database",
    "Laravel Log Dosyası": "Laravel Log Dosyası",
    "Toplam": "Toplam",
    "laravel log": "Laravel Log",
    "Silme başarısız.": "Silme başarısız.",
    "Banka": "Banka",
    "Bankaları güncelle": "Bankaları güncelle",
    "Tatil": "Tatil",
    "Tatilleri güncelle": "Tatilleri güncelle",
    "İl/İlçe": "İl/İlçe",
    "İl ve ilçeleri güncelle": "İl ve ilçeleri güncelle"
  }
}
